











































import { snakeCase } from 'lodash'
import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { SuccessChannelInfo } from '../../../../../../../../../../../../models/CheckChannels/CheckChannels'
import { BaseFlowButtonWithOutput } from '../../../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import CustomEditor from '../../../../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../../../../Helpers/ChannelsInfoHelper'
import UsersInfoHelper from '../../../../../../../../Helpers/UserInfoHelper'
import { NotifyGroupAction } from '../../../../../../Action/logic/Actions/NotifyGroupAction/NotifyGroupAction'
import { NotifyUsersAction } from '../../../../../../Action/logic/Actions/NotifyUsersAction/NotifyUsersAction'

@Component({
  data() {
    return {
      snakeCase,
      UsersInfoHelper,
      ChannelsInfoHelper
    }
  }
})
export default class NotifyUsersValues extends Vue{
  @Prop() action!: NotifyUsersAction | NotifyGroupAction

  @Prop() i18n!: i18n

  @Prop() editor!: CustomEditor

  get values(): Array<string> {
    const result: Array<string> = []

    if (this.action instanceof NotifyUsersAction) {
      this.action.users.forEach((u) => {
        const user = UsersInfoHelper.getUser(u)

        if (user) {
          result.push(user.info.name)
        }
      })
    } else {
      if (this.action.group) {
        const channel = ChannelsInfoHelper.GetChannel(this.action.group.toString())

        if (channel && channel instanceof SuccessChannelInfo) {
          result.push(channel.info.title)
        }
      }
    }

    return result
  }

  get buttonsWithSockets(): Array<string> {
    const result: Array<string> = []

    if (this.action.variants.length) {
      this.action.variants[0].buttons.forEach((r) => r.forEach((b) => {
        if (b instanceof BaseFlowButtonWithOutput) {
          result.push(b.text)
        }
      }))
    }

    return result
  }
}
